import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { LoadingBarProvider } from "./context/LoadingContextProvider";
import AppLoadingBar from "./components/AppLoadingBar";
import { ToastProvider } from "./context/ToastProvider";
import { DialogProvider } from "./context/DialogProvider";
import CommonDialog from "./components/dialogs/CommonDialog";
import ScrollToTopButton from "./components/buttons/ScrollToTopButton";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Disable console logging in production environment
if (process.env.NODE_ENV === "production") {
    console.log = function () {};
}

root.render(
    // <React.StrictMode>
    <BrowserRouter>
        <ToastProvider>
            <DialogProvider>
                <LoadingBarProvider>
                    <AuthProvider>
                        <AppLoadingBar />
                        <CommonDialog />
                        <App />
                        <ScrollToTopButton />
                    </AuthProvider>
                </LoadingBarProvider>
            </DialogProvider>
        </ToastProvider>
    </BrowserRouter>
    // </React.StrictMode>
);

reportWebVitals();
